var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "filter-section" },
          [
            _c(
              "el-form",
              {
                staticClass: "filter-form",
                attrs: { inline: true, model: _vm.listPram },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "订单号" } },
                  [
                    _c("el-input", {
                      staticClass: "order-input",
                      attrs: {
                        placeholder: "请输入订单编号",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.listPram.orderNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.listPram, "orderNo", $$v)
                        },
                        expression: "listPram.orderNo",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "商家订单号" } },
                  [
                    _c("el-input", {
                      staticClass: "order-input",
                      attrs: {
                        placeholder: "请输入订单编号",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.listPram.outOrderNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.listPram, "outOrderNo", $$v)
                        },
                        expression: "listPram.outOrderNo",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "订单状态" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticClass: "status-select",
                        attrs: {
                          placeholder: "请选择状态",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.listPram.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "status", $$v)
                          },
                          expression: "listPram.status",
                        },
                      },
                      _vm._l(_vm.orderStatusOptions, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "下单手机号" } },
                  [
                    _c("el-input", {
                      staticClass: "order-input",
                      attrs: {
                        placeholder: "请输入订单编号",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.listPram.phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.listPram, "phone", $$v)
                        },
                        expression: "listPram.phone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "充值手机号" } },
                  [
                    _c("el-input", {
                      staticClass: "order-input",
                      attrs: {
                        placeholder: "请输入订单编号",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.listPram.rechargePhone,
                        callback: function ($$v) {
                          _vm.$set(_vm.listPram, "rechargePhone", $$v)
                        },
                        expression: "listPram.rechargePhone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "商品名称" } },
                  [
                    _c("el-input", {
                      staticClass: "order-input",
                      attrs: {
                        placeholder: "请输入订单编号",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.listPram.spuName,
                        callback: function ($$v) {
                          _vm.$set(_vm.listPram, "spuName", $$v)
                        },
                        expression: "listPram.spuName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "Sku编码" } },
                  [
                    _c("el-input", {
                      staticClass: "order-input",
                      attrs: {
                        placeholder: "请输入订单编号",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.listPram.skuCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.listPram, "skuCode", $$v)
                        },
                        expression: "listPram.skuCode",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "下单小程序" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请输入选择", clearable: "" },
                        on: { change: _vm.handerSearch },
                        model: {
                          value: _vm.listPram.customerId,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "customerId", $$v)
                          },
                          expression: "listPram.customerId",
                        },
                      },
                      _vm._l(_vm.customers, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "下单时间" } },
                  [
                    _c("el-date-picker", {
                      staticClass: "date-picker",
                      attrs: {
                        type: "datetimerange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        format: "yyyy-MM-dd HH:mm:ss",
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                        size: "small",
                      },
                      on: { change: _vm.handleDateRangeChange },
                      model: {
                        value: _vm.dateRange,
                        callback: function ($$v) {
                          _vm.dateRange = $$v
                        },
                        expression: "dateRange",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-search",
                        },
                        on: { click: _vm.handerSearch },
                      },
                      [_vm._v("\n            搜索\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", icon: "el-icon-refresh" },
                        on: { click: _vm.resetSearch },
                      },
                      [_vm._v("\n            重置\n          ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "export-btn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-download",
                    },
                    on: { click: _vm.exportOrder },
                  },
                  [_vm._v("\n          导出订单\n        ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                height: "70vh",
                "highlight-current-row": "",
                "header-cell-style": {
                  fontWeight: "bold",
                  textAlign: "center",
                },
                "cell-style": { textAlign: "center" },
                stripe: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "orderNo", label: "订单号", "min-width": "200" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuCode",
                  label: "Sku编码",
                  "min-width": "200",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuName",
                  label: "产品名称",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalQuantity",
                  label: "商品数量",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "companyName",
                  label: "小程序",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getAppName(scope.row.customerId))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "skuPrice", label: "单价", "min-width": "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "realPrice", label: "面值", "min-width": "100" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalRealPrice",
                  label: "充值总面值",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fuCardName",
                  label: "充值福卡",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalPrice",
                  label: "订单金额",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticStyle: { color: "#E6A23C" } }, [
                          _vm._v("¥" + _vm._s(scope.row.totalPrice || "0.00")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "discount",
                  label: "总优惠金额",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticStyle: { color: "#67C23A" } }, [
                          _vm._v("¥" + _vm._s(scope.row.discount || "0.00")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "statusName",
                  label: "订单状态",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "下单时间",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "支付时间",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "username",
                  label: "下单用户",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "100",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openOrderDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n            查看详情\n          ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticStyle: { "margin-top": "20px", "text-align": "right" },
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "order-detail-dialog",
          attrs: {
            title: "订单详情",
            visible: _vm.detailDialogVisible,
            width: "1000px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
            close: _vm.handleDetailClose,
          },
        },
        [
          _vm.detailDialogVisible
            ? _c("OrderDetailComponent", {
                attrs: {
                  orderNo: _vm.currentOrderId,
                  orderDetail: _vm.orderDetail,
                  loading: _vm.detailLoading,
                },
                on: {
                  "loading-change": _vm.handleDetailLoadingChange,
                  "detail-loaded": _vm.handleDetailLoaded,
                  error: _vm.handleDetailError,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.detailDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }